import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { TableModule } from 'primeng/table';
import { TreeModule } from 'primeng/tree';
import { LogDisplayComponent } from './log-display.component';
import { InputTextModule } from 'primeng/inputtext';
import {ProgressSpinnerModule} from "primeng/progressspinner";



@NgModule({
  declarations: [LogDisplayComponent],
    imports: [
        CommonModule,
        TreeModule,
        ButtonModule,
        MessageModule,
        MenuModule,
        TableModule,
        InputTextModule,
        ProgressSpinnerModule
    ],
  exports: [LogDisplayComponent]
})
export class LogDisplayModule { }
